import useResponsiveWidth from "@/elements/hooks/use-responsive-width";
import React, { ReactNode } from "react";
import { View } from "react-native";

function ResponsiveContent({
  children,
  flex,
  className = "",
}: {
  children: ReactNode;
  flex?: boolean;
  className?: string;
}) {
  const responsiveWidth = useResponsiveWidth();

  return (
    <View
      style={{ width: responsiveWidth, flex: flex ? 1 : undefined }}
      className={`self-center ${className}`}
    >
      {children}
    </View>
  );
}

export default ResponsiveContent;
